<template>
  <!-- Container to display all global notices -->
  <div>
    <div v-for="notice in activeNotices">
      <notice :notice="notice"></notice>
    </div>
  </div>
</template>

<script>
  import Notice from './Notice'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'Notices',
    computed: {
      ...mapState({
        loggedIn: state => state.user.loggedIn
      }),
      ...mapGetters([
        'activeNotices'
      ])
    },
    watch: {
      loggedIn (newVal, oldVal) {
        if (newVal && !oldVal) {
          this.$store.dispatch('getNotices')
        }
      }
    },
    components: {
      Notice
    }
  }
</script>



// WEBPACK FOOTER //
// Notices.vue?6af8b5c5